export default __webpack_public_path__ + "static/ASLA_Helio_2-3cd8e10351708f1c0a9d60a1e98d23d7.png";